// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CannotFindPropertyfromJsonError = exports.SolutionVersionMissingError = exports.PathAlreadyExistsError = exports.ImportSPFxSolutionError = exports.UpdateSPFxTemplateError = exports.RetrieveSPFxInfoError = exports.CopyExistingSPFxSolutionError = exports.YoGeneratorScaffoldError = exports.PackageTargetVersionInstallError = exports.LatestPackageInstallError = exports.DevEnvironmentSetupError = exports.DependencyValidateError = exports.ScaffoldError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const constants_1 = require("./utils/constants");
const localizeUtils_1 = require("../../../common/localizeUtils");
function ScaffoldError(error) {
    if (error instanceof teamsfx_api_1.UserError || error instanceof teamsfx_api_1.SystemError) {
        return error;
    }
    else {
        return new teamsfx_api_1.SystemError({
            error: error,
            source: constants_1.Constants.PLUGIN_NAME,
            name: "SPFxScaffoldError",
        });
    }
}
exports.ScaffoldError = ScaffoldError;
function DependencyValidateError(dependency) {
    return new teamsfx_api_1.SystemError(constants_1.Constants.PLUGIN_NAME, "InvalidDependency", (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.invalidDependency", dependency), (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.invalidDependency", dependency));
}
exports.DependencyValidateError = DependencyValidateError;
function DevEnvironmentSetupError() {
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "DevEnvironmentSetupError",
        message: (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.devEnvironmentNotSetup"),
        displayMessage: (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.devEnvironmentNotSetup"),
        helpLink: constants_1.Constants.SetUpDevEnvironmentHelpLink,
    });
}
exports.DevEnvironmentSetupError = DevEnvironmentSetupError;
function LatestPackageInstallError() {
    const fxFolderPath = "HOME/.fx";
    return new teamsfx_api_1.SystemError(constants_1.Constants.PLUGIN_NAME, "LatestPackageInstallFailed", (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.installLatestDependencyError", fxFolderPath, constants_1.Constants.SetUpDevEnvironmentHelpLink), (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.installLatestDependencyError", fxFolderPath, constants_1.Constants.SetUpDevEnvironmentHelpLink));
}
exports.LatestPackageInstallError = LatestPackageInstallError;
function PackageTargetVersionInstallError(packageName, version) {
    const fxFolderPath = "HOME/.fx";
    const packageInfo = `${packageName}@${version}`;
    return new teamsfx_api_1.SystemError(constants_1.Constants.PLUGIN_NAME, "PackageTargetVersionInstallError", (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.installDependencyError", fxFolderPath, constants_1.Constants.AddWebpartHelpLink, packageInfo), (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.installDependencyError", fxFolderPath, constants_1.Constants.AddWebpartHelpLink, packageInfo));
}
exports.PackageTargetVersionInstallError = PackageTargetVersionInstallError;
function YoGeneratorScaffoldError() {
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "ScaffoldFailed",
        message: (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.scaffoldError", "command:fx-extension.showOutputChannel"),
        displayMessage: (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.scaffoldError", "command:fx-extension.showOutputChannel"),
        helpLink: constants_1.Constants.ScaffoldHelpLink,
    });
}
exports.YoGeneratorScaffoldError = YoGeneratorScaffoldError;
function CopyExistingSPFxSolutionError(e) {
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "CopyExistingSPFxSolutioinFailed",
        message: (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.import.copySPFxSolution", e.message),
        displayMessage: (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.import.copySPFxSolution", e.message),
        helpLink: constants_1.Constants.IMPORT_HELP_LINK,
    });
}
exports.CopyExistingSPFxSolutionError = CopyExistingSPFxSolutionError;
function RetrieveSPFxInfoError() {
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "RetrieveSPFxInfoFailed",
        message: (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.import.retrieveSolutionInfo"),
        displayMessage: (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.import.retrieveSolutionInfo"),
        helpLink: constants_1.Constants.IMPORT_HELP_LINK,
    });
}
exports.RetrieveSPFxInfoError = RetrieveSPFxInfoError;
function UpdateSPFxTemplateError(e) {
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "UpdateSPFxTemplateFailed",
        message: (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.import.updateSPFxTemplate", e.message),
        displayMessage: (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.import.updateSPFxTemplate", e.message),
        helpLink: constants_1.Constants.IMPORT_HELP_LINK,
    });
}
exports.UpdateSPFxTemplateError = UpdateSPFxTemplateError;
function ImportSPFxSolutionError(e) {
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "ImportSPFxSolutionFailed",
        message: (0, localizeUtils_1.getDefaultString)("plugins.spfx.error.import.common", e.message),
        displayMessage: (0, localizeUtils_1.getLocalizedString)("plugins.spfx.error.import.common", e.message),
        helpLink: constants_1.Constants.IMPORT_HELP_LINK,
    });
}
exports.ImportSPFxSolutionError = ImportSPFxSolutionError;
function PathAlreadyExistsError(path) {
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "PathAlreadyExists",
        message: (0, localizeUtils_1.getDefaultString)("core.QuestionAppName.validation.pathExist", path),
        displayMessage: (0, localizeUtils_1.getLocalizedString)("core.QuestionAppName.validation.pathExist", path),
    });
}
exports.PathAlreadyExistsError = PathAlreadyExistsError;
function SolutionVersionMissingError(path) {
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "SolutionVersionMissing",
        message: (0, localizeUtils_1.getDefaultString)("plugins.spfx.addWebPart.cannotFindSolutionVersion", path),
        displayMessage: (0, localizeUtils_1.getLocalizedString)("plugins.spfx.addWebPart.cannotFindSolutionVersion", path),
    });
}
exports.SolutionVersionMissingError = SolutionVersionMissingError;
function CannotFindPropertyfromJsonError(field) {
    const message = `Cannot find property "${field}" from json.`;
    return new teamsfx_api_1.UserError({
        source: constants_1.Constants.PLUGIN_NAME,
        name: "CannotFindPropertyfromJson",
        message,
        displayMessage: message, // This message won't be shown to users. No need to localize.
    });
}
exports.CannotFindPropertyfromJsonError = CannotFindPropertyfromJsonError;
//# sourceMappingURL=error.js.map